import * as yup from 'yup';
import messages from 'utils/constants/messages';

export default yup.object().shape({
  emailAddress: yup
    .string()
    .email(messages.formValidations.invalidEmail)
    .required(messages.formValidations.invalidEmail),
  password: yup.string().required(messages.formValidations.needValue),
});
